import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 语言包
const messages = {
  zh: {
    N01143: '说明',
    N00755: '是否删除该成员',
    N00810: '材料申请',
    N00811: '权限管理',
    N00812: '设备管理',
    N00813: '设备1',
    N00814: '设备2',
    N00815: '设备3',
    N00816: '设备4',
    N00817: '设备5',
    N00818: 'A区',
    N00819: 'B区',
    N00820: 'C区',
    N00821: 'D区',
    N00822: 'E区',
    N00823: 'F区',
    N00824: '确定',
    N00825: '取消',
    N00826: '删除',
    N00827: '编辑',
    N00828: '添加',
    N00829: '保存',
    N00830: '搜索',
    N00831: '刷新',
    N00832: '导出',
    N00833: '导入',
    N00834: '批量操作',
    N00835: '操作',
    N00836: '状态',
    N00837: '时间',
    N00838: '备注',
    N00839: '详情',
    N00840: '设备总览',
    N00841: '查看详情',
    N00842: '开始时间',
    N00843: '结束时间',
    N00844: '筛选间隔',
    N00845: '10分钟',
    N00846: '30分钟',
    N00847: '1小时',
    N00848: '4小时',
    N00849: '筛选单条数据',
    N00850: '风速折线图',
    N00851: '水流量折线图',
    N00852: '轴温折线图',
    N00853: '周一',
    N00854: '周二',
    N00855: '周三',
    N00856: '周四',
    N00857: '周五',
    N00858: '周六',
    N00859: '周日',
    N00860: '总览',
    N00861: '区域',
    N00862: '线别',
    N00863: '设备数',
    N00864: '开始日期',
    N00865: '结束日期',
    N00866: '错误',
    N00867: '获取接口错误',
    N00868: '服务器报错',
    N00873: '返回',
    N00874: '生产中',
    N00875: '故障中',
    N00876: '停止中',
    N00877: '离线中',
    N00878: 'E-Board建设中',
    N00879: '欢迎您!',
    N00880: '退出',
    N00884: '设备编号',
    N00885: '4线',
    N00886: '3线',
    N00887: '2线',
    N00888: '1线',
    N00889: 'A区',
    N00890: 'B区',
    N00891: 'C区',
    N00892: 'D区',
    N00893: 'E区',
    N00894: 'F区',
    N00895: '喷砂机',
    N00896: '开机时长',
    N00897: '停机时长',
    N00898: '离线时长',
    N00899: '加载中，请耐心等待',
    N00900: 'E-board',
    N00901: '运行',
    N00902: '停机',
    N00903: '离线',
    N00904: '风速',
    N00905: '正常',
    N00906: '异常',
    N00907: '离线',
    N00908: '线别',
    N00909: '水流状态',
    N00910: '轴承温度',
    N00911: '液位状态',
    N00912: '连锁实时状态',
    N00913: '保养状况',
    N00914: '开始时间',
    N00915: '结束时间',
    N00916: '搜索',
    N00917: '已保养数据',
    N00918: '待保养数据',
    N00919: '已保养',
    N00920: '待保养',
    N00921: '到期',
    N00922: '报警记录',
    N00923: '全部',
    N00924: '待处理导出',
    N00925: '已处理导出',
    N00926: '设备名称',
    N00927: '报警名称',
    N00928: '报警时间',
    N00929: '是否处理',
    N00930: '报警值',
    N00931: '处理',
    N00932: '未处理',
    N00933: '区域/楼栋/线别',
    N00934: '问题列表',
    N00935: '检查方式',
    N00936: '处理方法',
    N00937: '系统关机时间',
    N00938: '集尘设备恢复开机时间',
    N00939: '停机时长（分钟）',
    N00940: '改善完成时间',
    N00941: '已处理报警',
    N00942: 'open数量',
    N00943: '类型',
    N00944: '数量',
    N00945: '占比',
    N00946: '未处理报警数据',
    N00947: '报警记录',
    N00948: '失败',
    N00949: '暂无数据',
    N00950: '能耗',
    N00951: '导出数据',
    N00952: '设备名',
    N00953: '区域',
    N00954: '行线',
    N00955: '集尘机开机时长',
    N00956: '用电量',
    N00957: '能耗数据',
    N00958: '正常用电',
    N00959: '度',
    N00960: '用电量',
    N00961: '开机时长',
    N00962: '参数管理',
    N00963: '日志管理',
    N00964: '异常数据导出',
    N00965: '设备名称',
    N00966: '设备编号',
    N00967: '参数端口',
    N00968: '修改时间',
    N00969: '测试值',
    N00970: '结果',
    N00971: '参数值',
    N00972: '水流量标准值',
    N00973: '液位标准值',
    N00974: '轴温标准值',
    N00975: '风速标准值',
    N00976: '连锁测试',
    N00977: '参数异常修改',
    N00978: '未配置归属',
    N00979: '区域',
    N00980: '线别',
    N00981: '开始时间',
    N00982: '结束时间',
    N00983: '搜索',
    N00984: '加载中，请耐心等待',
    N00985: '其他',
    N00986: '数量',
    N00987: '占比',
    N00988: '联锁测试数据',
    N00989: '异常数据',
    N00990: '全部',
    N00991: '正常',
    N00992: '序号',
    N00993: '用户名',
    N00994: '操作记录',
    N00995: 'IP',
    N00996: '时间',
    N00997: '品牌商',
    N00998: '全部',
    N00999: '风速数据',
    N01000: '区域',
    N01001: '线别',
    N01002: '开始时间',
    N01003: '结束时间',
    N01004: '筛选间隔',
    N01005: '10分钟',
    N01006: '30分钟',
    N01007: '1小时',
    N01008: '4小时',
    N01009: '搜索',
    N01010: '导出数据',
    N01011: '端口',
    N01012: '风速',
    N01013: '时间',
    N01014: '结果',
    N01015: '加载中，请耐心等待',
    N01016: '轴温数据',
    N01017: '轴温',
    N01018: '液位数据',
    N01019: '液位',
    N01020: '水流数据',
    N01021: '水流',
    N01022: 'm/s标准',
    N01023: 'm/s预警',
    N01024: 'm/s',
    N01025: '℃标准',
    N01026: '℃预警',
    N01027: '℃',
    N01028: '标准',
    N01029: '预警',
    N01030: 'mm',
    N01031: 'm³/h标准',
    N01032: 'm³/h预警',
    N01033: 'm³/h',
    N01034: '风速/日期',
    N01035: '水流/日期',
    N01036: '液位/日期',
    N01037: '轴温/日期',
    N01038: '联锁测试数据导出',
    N01039: '单机水流',
    N01040: '单机水流标准值'
  },
  en: {
    N01143: 'Description',
    N00755: 'Are you sure to delete this member?',
    N00810: 'Material Application',
    N00811: 'Permission Management',
    N00812: 'Device Management',
    N00813: 'Device 1',
    N00814: 'Device 2',
    N00815: 'Device 3',
    N00816: 'Device 4',
    N00817: 'Device 5',
    N00818: 'Area A',
    N00819: 'Area B',
    N00820: 'Area C',
    N00821: 'Area D',
    N00822: 'Area E',
    N00823: 'Area F',
    N00824: 'Confirm',
    N00825: 'Cancel',
    N00826: 'Delete',
    N00827: 'Edit',
    N00828: 'Add',
    N00829: 'Save',
    N00830: 'Search',
    N00831: 'Refresh',
    N00832: 'Export',
    N00833: 'Import',
    N00834: 'Batch Operation',
    N00835: 'Operation',
    N00836: 'Status',
    N00837: 'Time',
    N00838: 'Remark',
    N00839: 'Details',
    N00840: 'Device Overview',
    N00841: 'View Details',
    N00842: 'Start Time',
    N00843: 'End Time',
    N00844: 'Filter Interval',
    N00845: '10 Minutes',
    N00846: '30 Minutes',
    N00847: '1 Hour',
    N00848: '4 Hours',
    N00849: 'Filter Single Data',
    N00850: 'Wind Speed Line Chart',
    N00851: 'Water Flow Line Chart',
    N00852: 'Shaft Temperature Line Chart',
    N00853: 'Monday',
    N00854: 'Tuesday',
    N00855: 'Wednesday',
    N00856: 'Thursday',
    N00857: 'Friday',
    N00858: 'Saturday',
    N00859: 'Sunday',
    N00860: 'Overview',
    N00861: 'Area',
    N00862: 'Line',
    N00863: 'Device Count',
    N00864: 'Start Date',
    N00865: 'End Date',
    N00866: 'Error',
    N00867: 'API Error',
    N00868: 'Server Error',
    N00873: 'Back',
    N00874: 'In Production',
    N00875: 'Fault',
    N00876: 'Stopped',
    N00877: 'Offline',
    N00878: 'E-Board Under Construction',
    N00879: 'Welcome!',
    N00880: 'Logout',
    N00884: 'Device Number',
    N00885: 'Line 4',
    N00886: 'Line 3',
    N00887: 'Line 2',
    N00888: 'Line 1',
    N00889: 'Area A',
    N00890: 'Area B',
    N00891: 'Area C',
    N00892: 'Area D',
    N00893: 'Area E',
    N00894: 'Area F',
    N00895: 'Sandblasting Machine',
    N00896: 'Running Time',
    N00897: 'Stop Time',
    N00898: 'Offline Time',
    N00899: 'Loading, please wait patiently',
    N00900: 'E-board',
    N00901: 'Running',
    N00902: 'Stopped',
    N00903: 'Offline',
    N00904: 'Wind Speed',
    N00905: 'Normal',
    N00906: 'Abnormal',
    N00907: 'Offline',
    N00908: 'Line',
    N00909: 'Water Flow Status',
    N00910: 'Bearing Temperature',
    N00911: 'Liquid Level Status',
    N00912: 'Chain Real-time Status',
    N00913: 'Maintenance Status',
    N00914: 'Start Time',
    N00915: 'End Time',
    N00916: 'Search',
    N00917: 'Maintained Data',
    N00918: 'Pending Maintenance Data',
    N00919: 'Maintained',
    N00920: 'Pending',
    N00921: 'Overdue',
    N00922: 'Alarm Records',
    N00923: 'All',
    N00924: 'Export Pending',
    N00925: 'Export Processed',
    N00926: 'Device Name',
    N00927: 'Alarm Name',
    N00928: 'Alarm Time',
    N00929: 'Processed',
    N00930: 'Alarm Value',
    N00931: 'Processed',
    N00932: 'Unprocessed',
    N00933: 'Area/Building/Line',
    N00934: 'Problem List',
    N00935: 'Check Method',
    N00936: 'Solution',
    N00937: 'System Shutdown Time',
    N00938: 'Dust Collection Device Restart Time',
    N00939: 'Downtime (minutes)',
    N00940: 'Improvement Completion Time',
    N00941: 'Processed Alarms',
    N00942: 'Open Count',
    N00943: 'Type',
    N00944: 'Count',
    N00945: 'Percentage',
    N00946: 'Unprocessed Alarm Data',
    N00947: 'Alarm Records',
    N00948: 'Failed',
    N00949: 'No Data',
    N00950: 'Energy Consumption',
    N00951: 'Export Data',
    N00952: 'Device Name',
    N00953: 'Area',
    N00954: 'Line',
    N00955: 'Dust Collector Running Time',
    N00956: 'Power Consumption',
    N00957: 'Energy Consumption Data',
    N00958: 'Normal Power Usage',
    N00959: 'kWh',
    N00960: 'Power Consumption',
    N00961: 'Running Time',
    N00962: 'Parameter Management',
    N00963: 'Log Management',
    N00964: 'Export Abnormal Data',
    N00965: 'Device Name',
    N00966: 'Device Number',
    N00967: 'Parameter Port',
    N00968: 'Modification Time',
    N00969: 'Test Value',
    N00970: 'Result',
    N00971: 'Parameter Value',
    N00972: 'Water Flow Standard Value',
    N00973: 'Liquid Level Standard Value',
    N00974: 'Shaft Temperature Standard Value',
    N00975: 'Wind Speed Standard Value',
    N00976: 'Interlock Test',
    N00977: 'Parameter Abnormal Modification',
    N00978: 'Not Configured',
    N00979: 'Area',
    N00980: 'Line',
    N00981: 'Start Time',
    N00982: 'End Time',
    N00983: 'Search',
    N00984: 'Loading, please wait patiently',
    N00985: 'Other',
    N00986: 'Count',
    N00987: 'Percentage',
    N00988: 'Interlock Test Data',
    N00989: 'Abnormal Data',
    N00990: 'All',
    N00991: 'Normal',
    N00992: 'No.',
    N00993: 'Username',
    N00994: 'Operation Record',
    N00995: 'IP',
    N00996: 'Time',
    N00997: 'Brand',
    N00998: 'All',
    N00999: 'Wind Speed Data',
    N01000: 'Area',
    N01001: 'Line',
    N01002: 'Start Time',
    N01003: 'End Time',
    N01004: 'Filter Interval',
    N01005: '10 Minutes',
    N01006: '30 Minutes',
    N01007: '1 Hour',
    N01008: '4 Hours',
    N01009: 'Search',
    N01010: 'Export Data',
    N01011: 'Port',
    N01012: 'Wind Speed',
    N01013: 'Time',
    N01014: 'Result',
    N01015: 'Loading, please wait patiently',
    N01016: 'Shaft Temperature Data',
    N01017: 'Shaft Temperature',
    N01018: 'Liquid Level Data',
    N01019: 'Liquid Level',
    N01020: 'Water Flow Data',
    N01021: 'Water Flow',
    N01022: 'm/s Standard',
    N01023: 'm/s Warning',
    N01024: 'm/s',
    N01025: '℃ Standard',
    N01026: '℃ Warning',
    N01027: '℃',
    N01028: 'Standard',
    N01029: 'Warning',
    N01030: 'mm',
    N01031: 'm³/h Standard',
    N01032: 'm³/h Warning',
    N01033: 'm³/h',
    N01034: 'Wind Speed/Date',
    N01035: 'Water Flow/Date',
    N01036: 'Liquid Level/Date',
    N01037: 'Shaft Temperature/Date',
    N01038: 'Interlock Test Data Export',
    N01039: 'single-unit water flow',
    N01040: 'Standard water flow rate per unit'
  },
  vn: {
    N01143: 'Mô tả',
    N00755: 'Bạn có muốn xóa thành viên này không?',
    N00810: 'Ứng dụng vật liệu',
    N00811: 'Quản lý quyền',
    N00812: 'Quản lý thiết bị',
    N00813: 'Thiết bị 1',
    N00814: 'Thiết bị 2',
    N00815: 'Thiết bị 3',
    N00816: 'Thiết bị 4',
    N00817: 'Thiết bị 5',
    N00818: 'Khu vực A',
    N00819: 'Khu B',
    N00820: 'Khu C',
    N00821: 'Khu D',
    N00822: 'Khu E',
    N00823: 'Khu F',
    N00824: 'Được',
    N00825: 'Hủy',
    N00826: 'Xóa',
    N00827: 'Chỉnh sửa',
    N00828: 'Thêm',
    N00829: 'Lưu',
    N00830: 'Tìm kiếm',
    N00831: 'Làm mới',
    N00832: 'Xuất',
    N00833: 'Nhập khẩu',
    N00834: 'Hoạt động hàng loạt',
    N00835: 'Hoạt động',
    N00836: 'Trạng thái',
    N00837: 'Thời gian',
    N00838: 'Nhận xét',
    N00839: 'Chi tiết',
    N00840: 'Tổng quan về thiết bị',
    N00841: 'Xem chi tiết',
    N00842: 'Thời gian bắt đầu',
    N00843: 'Thời điểm kết thúc',
    N00844: 'Khoảng thời gian lọc',
    N00845: '10 phút',
    N00846: '30 phút',
    N00847: '1 giờ',
    N00848: '4 giờ',
    N00849: 'Lọc dữ liệu đơn lẻ',
    N00850: 'Biểu đồ đường tốc độ gió',
    N00851: 'Biểu đồ dòng chảy nước',
    N00852: 'Biểu đồ đường nhiệt độ trục',
    N00853: 'Thứ Hai',
    N00854: 'Thứ ba',
    N00855: 'Thứ tư',
    N00856: 'Thứ năm',
    N00857: 'Thứ sáu',
    N00858: 'Thứ bảy',
    N00859: 'Chủ Nhật',
    N00860: 'Tổng quan',
    N00861: 'Khu vực',
    N00862: 'Loại đường',
    N00863: 'Số lượng thiết bị',
    N00864: 'Ngày bắt đầu',
    N00865: 'Ngày kết thúc',
    N00866: 'Lỗi',
    N00867: 'Lỗi khi nhận giao diện',
    N00868: 'Lỗi máy chủ',
    N00873: 'Trở về',
    N00874: 'Đang sản xuất',
    N00875: 'Thất bại',
    N00876: 'Đã dừng',
    N00877: 'Ngoại tuyến',
    N00878: 'E-Board đang được xây dựng',
    N00879: 'Chào mừng!',
    N00880: 'Thoát',
    N00884: 'Số thiết bị',
    N00885: '4 dòng',
    N00886: '3 dòng',
    N00887: '2 dòng',
    N00888: '1 dòng',
    N00889: 'Khu vực A',
    N00890: 'Khu B',
    N00891: 'Khu C',
    N00892: 'Khu D',
    N00893: 'Khu E',
    N00894: 'Khu F',
    N00895: 'Máy phun cát',
    N00896: 'Thời gian bật nguồn',
    N00897: 'Thời gian ngừng hoạt động',
    N00898: 'Thời gian ngoại tuyến',
    N00899: 'Đang tải, vui lòng kiên nhẫn chờ',
    N00900: 'Bảng điện tử',
    N00901: 'Chạy',
    N00902: 'Tắt máy',
    N00903: 'Ngoại tuyến',
    N00904: 'Tốc độ gió',
    N00905: 'Bình thường',
    N00906: 'Bất thường',
    N00907: 'Ngoại tuyến',
    N00908: 'Loại đường',
    N00909: 'Tình trạng dòng nước',
    N00910: 'Nhiệt độ chịu lực',
    N00911: 'Trạng thái mức chất lỏng',
    N00912: 'Trạng thái thời gian thực của chuỗi',
    N00913: 'Trạng thái bảo trì',
    N00914: 'Thời gian bắt đầu',
    N00915: 'Thời điểm kết thúc',
    N00916: 'Tìm kiếm',
    N00917: 'Dữ liệu được duy trì',
    N00918: 'Dữ liệu cần được duy trì',
    N00919: 'Đã được duy trì',
    N00920: 'Đang bảo trì',
    N00921: 'Hết hạn',
    N00922: 'Bản ghi báo động',
    N00923: 'Tất cả',
    N00924: 'Đang chờ xuất khẩu',
    N00925: 'Xuất khẩu đã xử lý',
    N00926: 'Tên thiết bị',
    N00927: 'Tên báo động',
    N00928: 'Thời gian báo thức',
    N00929: 'Bạn có muốn xử lý nó không?',
    N00930: 'Giá trị cảnh báo',
    N00931: 'Đang xử lý',
    N00932: 'Chưa xử lý',
    N00933: 'Khu vực/Tòa nhà/Đường',
    N00934: 'Danh sách câu hỏi',
    N00935: 'Kiểm tra phương pháp',
    N00936: 'Phương pháp xử lý',
    N00937: 'Thời gian tắt hệ thống',
    N00938: 'Thời gian khởi động lại thiết bị thu bụi',
    N00939: 'Thời gian ngừng hoạt động (phút)',
    N00940: 'Cải thiện thời gian hoàn thành',
    N00941: 'Đã xử lý báo động',
    N00942: 'Số lượng mở',
    N00943: 'Loại',
    N00944: 'Số lượng',
    N00945: 'Tỷ lệ',
    N00946: 'Dữ liệu cảnh báo chưa được xử lý',
    N00947: 'Bản ghi báo động',
    N00948: 'Thất bại',
    N00949: 'Chưa có dữ liệu',
    N00950: 'Tiêu thụ năng lượng',
    N00951: 'Xuất dữ liệu',
    N00952: 'Tên thiết bị',
    N00953: 'Khu vực',
    N00954: 'Dòng',
    N00955: 'Máy hút bụi bật nguồn đúng giờ',
    N00956: 'Tiêu thụ điện năng',
    N00957: 'Dữ liệu tiêu thụ năng lượng',
    N00958: 'Sử dụng điện năng bình thường',
    N00959: 'độ',
    N00960: 'Tiêu thụ điện năng',
    N00961: 'Thời gian bật nguồn',
    N00962: 'Quản lý tham số',
    N00963: 'Quản lý nhật ký',
    N00964: 'Xuất dữ liệu bất thường',
    N00965: 'Tên thiết bị',
    N00966: 'Số thiết bị',
    N00967: 'Cổng tham số',
    N00968: 'Thời gian sửa đổi',
    N00969: 'Giá trị thử nghiệm',
    N00970: 'Kết quả',
    N00971: 'Giá trị tham số',
    N00972: 'Giá trị tiêu chuẩn lưu lượng nước',
    N00973: 'Giá trị chuẩn mức chất lỏng',
    N00974: 'Giá trị chuẩn của nhiệt độ trục',
    N00975: 'Giá trị tiêu chuẩn tốc độ gió',
    N00976: 'Kiểm tra chuỗi',
    N00977: 'Bất thường về sửa đổi tham số',
    N00978: 'Không có thuộc tính nào được cấu hình',
    N00979: 'Khu vực',
    N00980: 'Loại đường',
    N00981: 'Thời gian bắt đầu',
    N00982: 'Thời điểm kết thúc',
    N00983: 'Tìm kiếm',
    N00984: 'Đang tải, vui lòng kiên nhẫn chờ',
    N00985: 'Khác',
    N00986: 'Số lượng',
    N00987: 'Tỷ lệ',
    N00988: 'Dữ liệu thử nghiệm liên kết',
    N00989: 'Dữ liệu bất thường',
    N00990: 'Tất cả',
    N00991: 'Bình thường',
    N00992: 'Số sê-ri',
    N00993: 'Tên người dùng',
    N00994: 'Bản ghi hoạt động',
    N00995: 'IP',
    N00996: 'Thời gian',
    N00997: 'Thương hiệu',
    N00998: 'Tất cả',
    N00999: 'Dữ liệu tốc độ gió',
    N01000: 'Khu vực',
    N01001: 'Loại đường',
    N01002: 'Thời gian bắt đầu',
    N01003: 'Thời điểm kết thúc',
    N01004: 'Khoảng thời gian lọc',
    N01005: '10 phút',
    N01006: '30 phút',
    N01007: '1 giờ',
    N01008: '4 giờ',
    N01009: 'Tìm kiếm',
    N01010: 'Xuất dữ liệu',
    N01011: 'Cảng',
    N01012: 'Tốc độ gió',
    N01013: 'Thời gian',
    N01014: 'Kết quả',
    N01015: 'Đang tải, vui lòng kiên nhẫn chờ',
    N01016: 'Dữ liệu nhiệt độ trục',
    N01017: 'Nhiệt độ trục',
    N01018: 'Dữ liệu mức chất lỏng',
    N01019: 'Mức chất lỏng',
    N01020: 'Dữ liệu lưu lượng nước',
    N01021: 'Dòng nước',
    N01022: 'tiêu chuẩn m/s',
    N01023: 'cảnh báo m/s',
    N01024: 'm/giây',
    N01025: '℃ tiêu chuẩn',
    N01026: '℃ cảnh báo',
    N01027: '℃',
    N01028: 'Tiêu chuẩn',
    N01029: 'Cảnh báo',
    N01030: 'mm',
    N01031: 'm³/h tiêu chuẩn',
    N01032: 'cảnh báo m³/h',
    N01033: 'm³/giờ',
    N01034: 'Tốc độ gió/ngày',
    N01035: 'Lưu lượng nước/ngày',
    N01036: 'Cấp độ/Ngày',
    N01037: 'Nhiệt độ trục/ngày',
    N01038: 'Xuất dữ liệu thử nghiệm liên kết',
    N01039: 'dòng nước đơn lẻ',
    N01040: 'Giá trị tiêu chuẩn lưu lượng nước của một đơn vị'
  }
}

const i18n = new VueI18n({
  locale: 'zh', // 设置默认语言
  messages
})

// 全局挂载 $lang 方法
Vue.prototype.$lang = (key, tip) => {
  return i18n.t(key)
}

export default i18n 